import React from "react";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Tooltip from "material-ui/Tooltip";
import { withStyles } from "material-ui/styles";
import styles from "../styles";
import {
  checkSmartFlags,
  resetSmartFlags
} from "../../../redux/actions";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {toast} from "react-toastify";
import { isCometType } from "../../../common/utils";

class Toolbar extends React.Component {
  toggle() {
    this.setState({
      search: !this.state.search
    });
  }

  toggleSmartFlags() {
    const {
      job,
      checkSmartFlags,
      resetSmartFlags,
      smartFlagChecksDone,
      translate
    } = this.props;

    if (!job?.effectiveSmartFlagProfileId) {
      resetSmartFlags();
      toast.info(translate('smart_flags_profile_not_selected'), {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
      })
      return;
    }

    if (smartFlagChecksDone) {
      resetSmartFlags();
    } else {
      toast.info(translate('smart_flags_checking'), {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
      })

      checkSmartFlags(job.id);
    }
  }

  render() {
    const {
      classes,
      translate,
      toggle,
      add,
      showMove,
      showEdit,
      move,
      showDelete,
      del,
      edit,
      showRecert,
      recert,
      showReportGen,
      reportGen,
      toggleFilters,
      createEnabled,
      refresh,
      job,
      editJobDetails
    } = this.props;

    let disableControlButtons = false;
    if (job && job.pendingcount) {
      disableControlButtons = true;
    }

    return (
      <div>
        <Tooltip
          title={translate("tooltip_reload_tests")}
          disableTriggerFocus={true}
        >
          <Button
            className={classes.button}
            color="primary"
            fab
            mini
            onClick={() => refresh()}
          >
            <Icon>refresh</Icon>
          </Button>
        </Tooltip>
        {createEnabled && (
          <Tooltip
            title={translate("tooltip_create_tests")}
            disableTriggerFocus={true}
          >
            <Button
              aria-label="Create Tests"
              className={classes.button}
              color="primary"
              fab
              mini
              onClick={() => add()}
              disabled={disableControlButtons}
            >
              <Icon>add</Icon>
            </Button>
          </Tooltip>
        )}
        {showEdit && (
          <Tooltip title={translate("test_edit_title")} disableTriggerFocus={true}>
            <Button
              aria-label="Edit Test"
              className={classes.button}
              color="primary"
              fab
              mini
              onClick={() => edit()}
              disabled={disableControlButtons}
            >
              <Icon>edit</Icon>
            </Button>
          </Tooltip>
        )}
        {showRecert && (
          <Tooltip
            title={translate("tooltip_recertify")}
            disableTriggerFocus={true}
          >
            <Button
              aria-label="Recertify"
              className={classes.button}
              color="primary"
              fab
              mini
              onClick={() => recert()}
              disabled={disableControlButtons}
            >
              <Icon>repeat</Icon>
            </Button>
          </Tooltip>
        )}
        {showMove && (
          <Tooltip
            title={translate("tooltip_move_tests")}
            disableTriggerFocus={true}
          >
            <Button
              aria-label="Move Tests"
              className={classes.button}
              color="primary"
              fab
              mini
              onClick={() => move()}
              disabled={disableControlButtons}
            >
              <Icon>folder</Icon>
            </Button>
          </Tooltip>
        )}
        {showDelete && (
          <Tooltip
            title={translate("tooltip_delete")}
            disableTriggerFocus={true}
          >
            <Button
              aria-label="Delete"
              className={classes.button}
              color="primary"
              fab
              mini
              onClick={() => del()}
              disabled={disableControlButtons}
            >
              <Icon>delete</Icon>
            </Button>
          </Tooltip>
        )}
        {showReportGen && (
          <Tooltip
            title={translate("tooltip_create_report")}
            disableTriggerFocus={true}
          >
            <Button
              aria-label="Create Report"
              className={classes.button}
              color="primary"
              fab
              mini
              onClick={() => reportGen()}
              disabled={disableControlButtons}
            >
              <Icon>insert_drive_file</Icon>
            </Button>
          </Tooltip>
        )}
        <Tooltip title={translate("tooltip_filter")} disableTriggerFocus={true}>
          <Button
            aria-label="Filter"
            className={classes.button}
            color="primary"
            fab
            mini
            onClick={() => toggleFilters()}
          >
            <Icon>filter_list</Icon>
          </Button>
        </Tooltip>
        <Tooltip
          title={translate("tooltip_view_columns")}
          disableTriggerFocus={true}
        >
          <Button
            aria-label="View Columns"
            className={classes.button}
            color="primary"
            fab
            mini
            onClick={() => toggle()}
          >
            <Icon>view_column</Icon>
          </Button>
        </Tooltip>
        {editJobDetails && (
          <Tooltip title={translate("job_edit")} disableTriggerFocus={true}>
            <Button
              aria-label="Edit Job"
              className={classes.button}
              color="primary"
              fab
              mini
              onClick={() => editJobDetails()}
            >
              <Icon>edit</Icon>
            </Button>
          </Tooltip>
        )}
        {this.props.appSettingReducer?.activeFeatures?.some(f => f.featureName === 'smart_flag') &&
        job && isCometType(job.deviceid) &&
        <Tooltip
          title={translate("tooltip_check_smart_flags")}
          disableTriggerFocus={true}
        >
          <Button
            aria-label="Check Smart Flags"
            className={classes.button}
            color="primary"
            fab
            mini
            onClick={() => this.toggleSmartFlags()}
          >
            <Icon>flag</Icon>
          </Button>
        </Tooltip>}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  smartFlagChecksDone: state.smartFlagReducer.smartFlagChecksDone,
  ...state
});

export default connect(mapStateToProps)
(withRouter(withStyles(styles)(Toolbar)));
